<div class="tw-w-full tw-relative tw-h-full tw-flex tw-flex-col tw-bg-gray-100 tw-rounded-t-3xl tw-overflow-hidden">
  <span class="tw-w-20 tw-h-0.75 tw-rounded-lg tw-absolute tw-top-1 tw-left-1/2 -tw-translate-x-1/2 tw-bg-gray-300"></span>
  <div class="tw-w-full tw-shrink-0 tw-flex tw-justify-between tw-items-center tw-px-4 tw-pb-4 tw-pt-5 tw-tracking-tight tw-bg-white">
    <div class="tw-flex tw-items-center tw-gap-2">
      <img src="https://cdn.cureskin.com/app/img/ai-star.svg" alt="">
      <h1 class="tw-text-300 tw-font-semibold" i18n="@@cureskinHealthAssistant">Cure AI Health Assistant</h1>
    </div>
    <button type="button" aria-label="Close" class="tw-h-auto tw-min-w-0 !tw-mx-0 tw-p-0 tw-bg-transparent tw-text-gray-500 tw-text-500 tw-font-bold" (click)="closePopup()">&#10005;</button>
  </div>
  <div class="tw-w-full tw-bg-gray-100 tw-px-1 tw-relative tw-flex tw-flex-col tw-flex-1 tw-min-h-0">
    @if (initialLoading()) {
      <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-2">
        <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-t-teal-500"></div>
      </div>
    }
    @if (!initialLoading()) {
      <div #scrollContainer class="tw-flex-1 tw-min-h-0 tw-overflow-y-scroll tw-py-3 tw-px-3"
        (scroll)="onScroll()">
        @if (loadingOldMessages()) {
          <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-2">
            <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-t-teal-500"></div>
          </div>
        }
        @for (row of messageRows(); track row.chat.objectId) {
          <div class="chat-bubble tw-w-full tw-flex tw-text-300"
            [class.tw-justify-end]="row.chat?.owner === AiAssistantOwner.USER"
            [class.tw-text-gray-800]="row.chat?.owner === AiAssistantOwner.USER"
            [class.tw-justify-start]="row.chat?.owner === AiAssistantOwner.BOT"
            [class.tw-text-gray-700]="row.chat?.owner === AiAssistantOwner.BOT">
            @if (row.chat?.owner === AiAssistantOwner.USER) {
              @if (row.showErrorBubble) {
                <div class="tw-flex tw-flex-col tw-items-end tw-mb-4 tw-max-w-chat-bubble-user">
                  <div class="tw-relative tw-bg-red-100 tw-text-red-900 tw-p-3 tw-rounded-t-xl tw-rounded-bl-xl tw-w-fit"
                    [class.tw-cursor-pointer]="row.canRetry"
                    [attr.role]="row.canRetry ? 'button' : null"
                    [attr.tabindex]="row.canRetry ? 0 : null"
                    [attr.aria-label]="row.canRetry ? 'Retry sending this message' : null"
                    (click)="onErrorBubbleClick(row)"
                    (keydown.enter)="onErrorBubbleClick(row)"
                    (keydown.space)="onErrorBubbleClick(row)">
                    {{ row.chat?.content }}
                    <span class="tw-absolute -tw-bottom-2 -tw-right-1 tw-w-5 tw-h-5 tw-rounded-full tw-bg-white tw-flex tw-items-center tw-justify-center">
                      <i class="tw-text-red-400 tw-text-200"
                        [class.cs-icon-refresh]="row.canRetry"
                        [class.cs-icon-close]="!row.canRetry"></i>
                    </span>
                  </div>
                  @if (row.canRetry) {
                    <span class="tw-text-200 tw-text-red-400 tw-mt-2" i18n="@@aiChatSomethingWentWrongRetry">Something went wrong · tap to retry</span>
                  } @else if (row.showStaleHint) {
                    <span class="tw-text-200 tw-text-red-400 tw-mt-2" i18n="@@aiChatSomethingWentWrong">Something went wrong</span>
                  }
                </div>
              } @else {
                <div class="tw-bg-teal-300 tw-p-3 tw-rounded-t-xl tw-rounded-bl-xl tw-w-fit tw-mb-4 tw-max-w-chat-bubble-user">{{ row.chat?.content }}</div>
              }
            }
            @if (row.chat?.owner === AiAssistantOwner.BOT) {
              <div class="tw-w-fit tw-max-w-chat-bubble tw-text-wrap tw-overflow-clip tw-mb-4 tw-flex tw-items-start tw-gap-2">
                <img src="/assets/icons/ai_ball_star.svg" class="tw-w-10" alt="">
                <div class="tw-flex tw-flex-col tw-gap-2">
                  <div class="tw-bg-white tw-border-gray-200 tw-p-3 tw-rounded-b-xl tw-rounded-tr-xl" [innerHTML]="convertTextToHtml(row.chat?.content)"></div>
                  @if (row.options.length) {
                    <div class="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-justify-start tw-items-start tw-pr-2 tw-mb-4">
                      @for (option of row.options; track option) {
                        <ng-container [ngTemplateOutlet]="chip" [ngTemplateOutletContext]="{ $implicit: option, chat: row.chat }"></ng-container>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (showThinking()) {
          <div class="tw-w-full tw-max-w-chat-bubble tw-mt-2 tw-flex tw-items-start tw-gap-2 tw-mb-10">
            <img src="/assets/icons/ai_ball_star_faded.svg" class="tw-w-10" alt="">
            <div class="tw-w-full tw-flex tw-flex-col">
              <span class="tw-mb-3 tw-text-200 tw-text-gray-500" i18n="@@thinking">Thinking...</span>
              <div class="tw-flex tw-flex-col tw-w-full tw-mt-1">
                <div class="thinking-bar thinking-bar-1 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
                <div class="thinking-bar thinking-bar-2 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
                <div class="thinking-bar thinking-bar-3 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="tw-w-full tw-shrink-0 tw-bg-gray-100 tw-pt-1 tw-pb-4">
        @if (suggestions().length && !showThinking()) {
          <div class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-overflow-x-auto hide-scrollbar tw-px-4 tw-pb-3">
            @for (suggestion of suggestions(); track suggestion) {
              <ng-container [ngTemplateOutlet]="chip" [ngTemplateOutletContext]="{ $implicit: suggestion, nowrap: true }"></ng-container>
            }
          </div>
        }
        <div class="tw-w-full tw-px-4">
          <div class="tw-w-full tw-flex tw-items-center tw-border tw-border-gray-200 tw-shadow-z9 tw-rounded-3 tw-bg-white">
            <textarea #msgInput id="ai-chat-message-input" aria-label="Ask Anything" class="tw-bg-white tw-py-3 tw-pl-3 tw-pr-2 tw-rounded-2xl tw-w-full tw-overflow-y-auto tw-min-h-12 tw-border-none"
              [disabled]="inputLocked()"
              [class.tw-text-teal-500]="isVoiceListening()"
              (input)="onDraftChange(msgInput.value)"
              (keydown.enter)="$event.preventDefault(); sendMessage(msgInput.value)"
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="4"
              name="message"
            placeholder="Ask Anything..." ></textarea>
            @if (isVoiceMicVisible()) {
              <voice-mic-input class="tw-mr-3"
                [showTooltip]="showVoiceTooltip()"
                (transcript)="onVoiceTranscript($event)"
                (stateChange)="onVoiceStateChange($event)"
              (tooltipShown)="dismissVoiceTooltip()"></voice-mic-input>
            }
            <button type="button" aria-label="Send"
              class="tw-h-auto tw-min-w-0 !tw-ml-0 !tw-mr-3 tw-w-fit tw-p-1.5 tw-rounded-full"
              [disabled]="inputLocked()"
              [class.tw-bg-gray-300]="!draft().trim() || inputLocked()"
              [class.tw-bg-teal-600]="!!draft().trim() && !inputLocked()"
              (click)="sendMessage(msgInput.value)">
              <img src="/assets/chat-send.svg" class="tw-w-6" alt="">
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #chip let-option let-chat="chat" let-nowrap="nowrap">
  <button type="button"
    class="tw-h-auto tw-min-w-0 !tw-mx-0 tw-normal-case tw-whitespace-normal !tw-font-normal tw-text-300 tw-bg-white tw-border tw-border-teal-500 tw-rounded-xl tw-py-2 tw-px-4 tw-shadow-z1 tw-text-teal-600"
    [class.tw-shrink-0]="nowrap"
    [class.tw-text-nowrap]="nowrap"
    (click)="handleInputClick(option, chat)">
    {{ option.text }}
  </button>
</ng-template>
